import styled from 'styled-components';

const Image = styled.img`
  max-width: 100%;
  padding: 10px;
`;

export default Image;


// WEBPACK FOOTER //
// ./src/components/markdown/Image.js